(function ($) {
  'use strict';

  var Forms = function (context, labelParent) {
    this.className = 'show-placeholder';

    this.context = context;
    this.labelParent = labelParent;

    var selectors = ['input', 'select', 'textarea'];

    selectors = selectors.map(
      function (el) {
        return this.context + ' ' + el;
      }.bind(this)
    );

    $(document).on('focus', selectors.join(','), this.focusField.bind(this));
    $(document).on('blur', selectors.join(','), this.blurField.bind(this));
  };

  Forms.prototype.reloadLabels = function (e) {
    $(e.currentTarget)
      .find('input, select, textarea')
      .each(
        function (index, el) {
          this.blurField({ currentTarget: el });
        }.bind(this)
      );
  };

  Forms.prototype.focusField = function (e) {
    $(e.currentTarget).closest(this.labelParent).removeClass(this.className);
  };

  Forms.prototype.blurField = function (e) {
    var $el = $(e.currentTarget);
    if ($el.val() === '') {
      $el.closest(this.labelParent).addClass(this.className);
    }
  };

  var wpforms = new Forms('.wpforms-form', '.wpforms-field');
  $(document).on(
    'WPForms:reload',
    '.wpforms-form',
    wpforms.reloadLabels.bind(wpforms)
  );

  var activityForm = new Forms('#user-activity form.login', 'div');

  $(document).ready(function () {
    $('.wpforms-form').trigger('WPForms:reload');
    $('#user-activity')
      .find('form.login')
      .each(function () {
        activityForm.reloadLabels({ currentTarget: this });
      });
  });

  $(document).on(
    'click touchstart',
    'form input[type=submit], form button[type=submit]',
    function () {
      var $checkboxes = $(this)
        .closest('form')
        .find('.checkbox input:required:not(:checked)');
      if ($checkboxes.length < 1) {
        return;
      }
      $checkboxes.each(function () {
        $(this)
          .closest('.checkbox')
          .addClass('error')
          .one('click touchstart', function (e) {
            if (
              e.type === 'touchstart' &&
              (!e.originalEvent || !e.originalEvent.cancelable)
            ) {
              return;
            }
            $(this).removeClass('error');
          });
      });
    }
  );
}).bind(window)(jQuery);
